import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeletionEntry, DeletionRegistryService } from '../services/deletion-registry.service';
import { DeletionGuardHandler } from './deletion-guard.handler';

@Injectable()
export class DeletionGuardInterceptor implements HttpInterceptor {
  private readonly registry: DeletionRegistryService = inject(DeletionRegistryService);
  private readonly handler: DeletionGuardHandler = inject(DeletionGuardHandler);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // we get list of items not only by GET request, but also by POST request with filters in body (e.g. for incidents)
    if (req.method !== 'GET' && req.method !== 'POST') {
      return next.handle(req);
    }

    const entry: DeletionEntry | null = this.registry.resolveEntry(req.url);

    if (!entry) {
      return next.handle(req);
    }

    return this.handler.attempt(req, (r) => next.handle(r), entry);
  }
}
